import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatCard, MatCardContent, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { MatIcon } from '@angular/material/icon'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatInput } from '@angular/material/input'
import { BankDetailsService } from '../../../core/services/bank/bank-details/bank-details.service'
import { ContractStatusService } from '../../../core/services/contract/contract-status/contract-status.service'
import { LegalEntityClientService } from '../../../core/services/customer/legal-entity-client/legal-entity-client.service'
import { MatOption, MatSelect } from '@angular/material/select'
import { ProfileService } from '../../../core/services/profile/profile.service'
import { UserManagementService } from '../../../core/services/user-management/user-management.service'
import { DriverManagementComponent } from '../../../pages/user-management/driver-management/driver-management.component'
import {
  EmployeeManagementComponent
} from '../../../pages/user-management/employee-management/employee-management.component'
import { MatTab, MatTabGroup, MatTabNavPanel } from '@angular/material/tabs'
import { NgTemplateOutlet } from '@angular/common'
import {
  ResponsibleSupplierManagementComponent
} from './responsible-supplier-management/responsible-supplier-management.component'
import { DriverSupplierManagementComponent } from './driver-supplier-management/driver-supplier-management.component'

@Component({
  selector: 'supplier-management-details',
  imports: [
    MatButton,
    ReactiveFormsModule,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    DriverManagementComponent,
    EmployeeManagementComponent,
    MatTab,
    MatTabGroup,
    MatFormField,
    MatLabel,
    MatInput,
    MatTabNavPanel,
    NgTemplateOutlet,
    MatCardContent,
    ResponsibleSupplierManagementComponent,
    DriverSupplierManagementComponent,
  ],
  templateUrl: './supplier-management-details.component.html',
  styleUrl: './supplier-management-details.component.scss',
  providers: [LegalEntityClientService],
  standalone: true,
})
export class SupplierManagementDetailsComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<SupplierManagementDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  @Output() response = new EventEmitter()
  isEditing: boolean = false
  itemEdit: any = {}
  form: FormGroup = new FormGroup({})
  loading: boolean = false
  ngOnInit(): void {
    this.itemEdit = this.data.item
    this.createForm()
  }
  createForm() {
    this.form = this.formBuilder.group({
      nome: [this.itemEdit.nome_fantasia],
      razao_social: [this.itemEdit.razao_social],
      cnpj: [this.itemEdit.cnpj],
    })
    this.form.get('nome')?.disable()
    this.form.get('razao_social')?.disable()
    this.form.get('cnpj')?.disable()
  }
  close() {
    this.dialogRef.close()
  }
}
